/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text, Box } from 'wt-ui';
import useAudioPlayer from '../../hooks/useAudioPlayer';
import useResponsive from '../../hooks/useResponsive';
import Pause from './Pause';
import Play from './Play';
import Bar from './Bar';
import './index.css';

const AudioPlayer = ({ audioLink, itemTitle }) => {
  const { ref, currentTime, duration, playing, setPlaying, setClickedTime } = useAudioPlayer();
  const { isTablet } = useResponsive();
  const getDurationValue = (value) => (value < 10 ? `0${value}` : value);
  const getDuration = (durationTime) => {
    const hours = Math.floor(durationTime / 3600);
    const minutes = Math.floor((durationTime % 3600) / 60);
    const seconds = Math.floor(durationTime % 60);

    if (hours > 0) {
      return `${getDurationValue(hours)}:${getDurationValue(
        minutes,
      )}:${getDurationValue(seconds)}`;
    }

    return `${getDurationValue(minutes)}:${getDurationValue(seconds)}`;
  };

  return (
    <Box
      background="transparent"
      className={classNames('box_background', {
        'box-animate': playing,
      })}
      pad="none"
      gap="none"
      fill
      flex
    >
      <Box
        background="transparent"
        direction="row-responsive"
        className="player"
        fill
        flex
        pad={{ left: '10px' }}
      >
        <audio ref={ref} className="multimedia-component audio">
          <source src={audioLink} />
          Your browser does not support the<code>audio</code>element.
        </audio>
        <Box
          background="transparent"
          direction="row-responsive"
          className={classNames({
            m_player_container: isTablet,
            lg_player_container: !isTablet,
          })}
        >
          {playing ? (
            <Pause
              handleClick={() => setPlaying(false)}
              itemTitle={itemTitle}
            />
          ) : (
            <Play handleClick={() => setPlaying(true)} itemTitle={itemTitle} />
          )}
        </Box>
      </Box>
      <Box
        background="transparent"
        direction="row-responsive"
        valign="bottom"
        gap="none"
        pad={{ left: '10px', right: '10px' }}
      >
        <div className="playtime_container">
          <Text className="bottom-left">{getDuration(currentTime)}</Text>
          <Text className="bottom-right">{getDuration(duration)}</Text>
        </div>
      </Box>
      <Bar
        duration={duration}
        curTime={currentTime}
        onTimeUpdate={(time) => setClickedTime(time)}
      />
    </Box>
  );
};

AudioPlayer.propTypes = {
  audioLink: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
};

export default AudioPlayer;
